module.exports = (require("./helpers/browser/import-polyfill")(parcelRequire.resolve("bn2wU"))).then(() => parcelRequire('a00pK'));